import * as React from "react"

import Layout from "../components/Layout"

const AMOLocation = () => {
  return (
    <Layout>
      <h1>AMO, Next To Thomson ...</h1>

      <iframe
        title="AMO_Location"
        width="100%"
        height="600px"
        src="/Location.pdf#toolbar=0"
      ></iframe>
    </Layout>
  )
}

export default AMOLocation
